// extracted by mini-css-extract-plugin
export var messageSideLeft = "_m5-1";
export var messageSideRight = "_m5-2";
export var subscribeToBackInStockBubbleContainer = "_m5-0";